import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Dumbbell, ShoppingBag, Apple, User } from "lucide-react";
import { motion } from "framer-motion";

const items = [
    { to: "/app", icon: Home, label: "Home", testid: "nav-home" },
    { to: "/app/challenges", icon: Dumbbell, label: "Train", testid: "nav-challenges" },
    { to: "/app/shop", icon: ShoppingBag, label: "Shop", testid: "nav-shop" },
    { to: "/app/diet", icon: Apple, label: "Diet", testid: "nav-diet" },
    { to: "/app/profile", icon: User, label: "Profile", testid: "nav-profile" },
];

export default function BottomNav() {
    return (
        <nav
            data-testid="bottom-nav"
            className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-40 bg-charcoal-900/95 backdrop-blur-md border-t border-charcoal-500"
        >
            <div className="grid grid-cols-5">
                {items.map((it) => (
                    <NavLink
                        key={it.to}
                        to={it.to}
                        end={it.to === "/app"}
                        data-testid={it.testid}
                        className={({ isActive }) =>
                            `relative flex flex-col items-center justify-center py-3 transition-all ${
                                isActive ? "text-neon-green" : "text-zinc-500"
                            }`
                        }
                    >
                        {({ isActive }) => (
                            <>
                                {isActive && (
                                    <motion.div
                                        layoutId="navActive"
                                        className="absolute top-0 left-3 right-3 h-0.5 bg-neon-green shadow-[0_0_12px_rgba(57,255,20,0.8)]"
                                    />
                                )}
                                <it.icon size={20} strokeWidth={2.4} />
                                <span className="text-[10px] font-display font-bold uppercase tracking-widest mt-1">
                                    {it.label}
                                </span>
                            </>
                        )}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
